import React from 'react'

export default function XIcon(props) {
    return (
        <svg {...props} aria-label="X mark" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.95159 0L0 3.95159L2.01783 5.96943L7.00637 11.042L2.01783 16.0306L0 17.9643L3.95159 22L5.96943 19.9822L11.042 14.9096L16.0306 19.9822L17.9643 22L22 17.9643L19.9822 16.0306L14.9096 11.042L19.9822 5.96943L22 3.95159L17.9643 0L16.0306 2.01783L11.042 7.00637L5.96943 2.01783L3.95159 0Z" fill="currentColor" />
        </svg>
    )
}